import moment from 'moment';
import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import {
  storeCustomerVoucherRequested,
  storeVoucherRequested,
  updateVoucherRequested,
} from 'store/vouchers/voucherSlice';

export function useStoreVoucher() {
  const dispatch = useDispatch();
  const onStoreVoucher = useCallback(
    async (values: any, actions: any) => {
      actions.setSubmitting(true);

      let data = {
        ...values,
        startDate: values?.startDate
          ? moment.utc(values?.startDate)?.format('YYYY-MM-DD')
          : null,
        endDate: values?.endDate
          ? moment.utc(values?.endDate)?.format('YYYY-MM-DD')
          : null,
        paperId: values?.paper?.id,
      };

      // values.startDate = values?.startDate
      //   ? moment.utc(values?.startDate)?.format('YYYY-MM-DD')
      //   : null;
      // values.endDate = values?.endDate
      //   ? moment.utc(values?.endDate)?.format('YYYY-MM-DD')
      //   : null;
      // values.paperId = values?.paper?.id;
      await dispatch(storeVoucherRequested(data));

      setTimeout(() => {
        actions.setSubmitting(false);
      }, 1000);
    },
    [dispatch]
  );
  return { onStoreVoucher };
}

export function useUpdateVoucher() {
  const dispatch = useDispatch();
  const onUpdateVoucher = useCallback(
    async (values: any) => {
      values.startDate = values?.startDate
        ? moment.utc(values?.startDate).format('YYYY-MM-DD')
        : null;
      values.endDate = values?.endDate
        ? moment.utc(values?.endDate).format('YYYY-MM-DD')
        : null;
      values.paperId = values?.paper?.id;
      await dispatch(updateVoucherRequested(values));
    },
    [dispatch]
  );
  return { onUpdateVoucher };
}

export function useStoreCustomerVoucher() {
  const dispatch = useDispatch();
  const onStoreCustomerVoucher = useCallback(
    async (values: any) => {
      values.startDate = values?.startDate
        ? moment.utc(values?.startDate)?.format('YYYY-MM-DD')
        : null;
      values.endDate = values?.endDate
        ? moment.utc(values?.endDate)?.format('YYYY-MM-DD')
        : null;
      values.paperId = values?.paper?.id;
      await dispatch(storeCustomerVoucherRequested(values));
    },
    [dispatch]
  );
  return { onStoreCustomerVoucher };
}
